module.exports = __webpack_public_path__ + "img/zahnrad.e611c94d.jpg";